module.exports = __webpack_public_path__ + "static/media/Slider2.c09c6403.png";